const apiUrl: string=import.meta.env.VITE_X_API_URL;
const clientId: string = import.meta.env.VITE_CLIENT_ID;
const authority: string = import.meta.env.VITE_AUTHORITY;
const redirectUri: string = import.meta.env.VITE_REDIRECT_URI;
const scope: string[] = import.meta.env.VITE_SCOPE ? JSON.parse(import.meta.env.VITE_SCOPE) : [];

const wsUrl = (apiUrl || '').replace(/\/api$/, '');

export const config = {
    apiUrl: apiUrl || '',
    wsUrl,
    clientId: clientId || '',
    authority: authority || '',
    redirectUri: redirectUri || '',
    scope: scope.length > 0 ? scope : [],
};

if (!config.apiUrl || !config.clientId || !config.authority || !config.redirectUri || config.scope.length === 0) {
    throw new Error('Config is not completely defined in the environment variables');
}